<script setup>
import { ref, useTemplateRef } from 'vue';
import { useLocalizationStore } from '../stores/localizationStore';
import { gsap } from 'gsap';
import { useRouter } from 'vue-router';
import Logo from '../components/Common/Logo.vue';

const router = useRouter();

const { $trans } = useLocalizationStore();

const button = useTemplateRef('button');
const backgroundImage = useTemplateRef('backgroundImage');

function onButtonClick(){
    button.value.classList.add('pointer-events-none');

    gsap.to(backgroundImage.value, {
        scale: 1.4,
        opacity: 0,
        duration: 0.7,
        ease: 'power2.in',
        onComplete: () => {
            router.push({name: 'categories'})
        }
    })
}

</script>

<template>
    <div class="size-full relative overflow-hidden isolate py-16 xl:py-24 4k:py-32 px-10 hd:px-16">
        <img ref="backgroundImage" class="absolute left-0 top-0 size-full object-cover opacity-60 -z-30" src="/bundles/salestool/assets/images/start.png">
        <div class="absolute left-0 top-0 size-full bg-gradient-vignette -z-20"></div>

        <div class="flex flex-col gap-y-16 xl:gap-y-28 4k:gap-y-40 items-center">
            <Logo />
            <h1 ref="headline" class="uppercase text-center r-text-135 max-w-[50rem] lg:max-w-[60rem] xl:max-w-[65rem] xxl:max-w-[80rem] 4k:max-w-[110rem] font-extra-light" v-text="$trans('start.title')"></h1>
            <button
                type="button"
                class="bg-primary font-bold r-text-22 uppercase px-8 pb-4 pt-6 shadow-button hover:scale-95 duration-300 ease-in-out transition-transform"
                @click="onButtonClick"
                ref="button"
                v-text="$trans('start.cta')"
            ></button>
        </div>
    </div>
</template>
